import { render, staticRenderFns } from "./institutionalProduct.vue?vue&type=template&id=1d1f670a&scoped=true"
import script from "./institutionalProduct.vue?vue&type=script&lang=js"
export * from "./institutionalProduct.vue?vue&type=script&lang=js"
import style0 from "./institutionalProduct.vue?vue&type=style&index=0&id=1d1f670a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1f670a",
  null
  
)

export default component.exports